// extracted by mini-css-extract-plugin
export var documentation = "_m5-1";
export var menu = "_m5-0";